import PropTypes from 'prop-types';
import React from 'react';
import Browser from '@wetransfer/concorde-browser';

import Icon from '@component/icon';

import { OSLO_GRAY } from '@constant/colors';

export default class Pagination extends React.Component {
  static propTypes = {
    pages: PropTypes.number,
    activePage: PropTypes.number,
    onClick: PropTypes.func,
    maxPages: PropTypes.number,
  };

  static defaultProps = {
    activePage: 0,
    maxPages: Browser.isMobile ? 4 : 5,
  };

  /**
   * Binds all private methods
   * @param  {Object} props Component props
   */
  constructor(props) {
    super(props);

    this.renderNumbers = this.renderNumbers.bind(this);
  }

  renderNumbers() {
    const selectedPos = Math.ceil(this.props.maxPages / 2);
    const start =
      this.props.activePage + 1 < selectedPos
        ? 1
        : this.props.activePage + 1 - selectedPos + 1;
    const len =
      this.props.pages < start + this.props.maxPages - 1
        ? this.props.pages - start + 1
        : this.props.maxPages;
    const numbers = Array(...Array(len)).map((u, i) => start + i);

    while (numbers.length < this.props.maxPages && numbers[0] > 1) {
      numbers.unshift(numbers[0] - 1);
    }

    return numbers.map((number, index) => {
      const className = ['pagination__digit'];
      let text = number;

      if (
        index === 0 &&
        number < selectedPos &&
        this.props.activePage > selectedPos - 1
      ) {
        text = '...';
      }
      if (
        index === selectedPos + 1 &&
        number < this.props.pages &&
        this.props.activePage + selectedPos + 1 <= this.props.pages
      ) {
        text = '...';
      }
      if (this.props.activePage === number - 1) {
        className.push('pagination__digit--active');
      }

      return (
        <div
          className={className.join(' ')}
          onClick={() => this.props.onClick(number - 1)}
          key={index}
        >
          {text}
        </div>
      );
    });
  }

  render() {
    const previousActive = this.props.activePage > 0;
    const nextActive = this.props.activePage + 1 !== this.props.pages;

    const previous = (
      <div
        className={
          'pagination__digit pagination__digit--arrow ' +
          (!previousActive ? 'pagination__digit--inactive' : '')
        }
        onClick={
          previousActive
            ? () => this.props.onClick(this.props.activePage - 1)
            : null
        }
      >
        <Icon type="Arrow" color={OSLO_GRAY} />
      </div>
    );

    const next = (
      <div
        className={
          'pagination__digit pagination__digit--arrow ' +
          (!nextActive ? 'pagination__digit--inactive' : '')
        }
        onClick={
          nextActive
            ? () => this.props.onClick(this.props.activePage + 1)
            : null
        }
      >
        <Icon orientation="right" type="Arrow" color={OSLO_GRAY} />
      </div>
    );

    return (
      <div className="pagination">
        {previous}
        {this.renderNumbers()}
        {next}
      </div>
    );
  }
}
